export let Code = {
type: `@Component({
    selector: 'p-dialog',
    template:
        <p-dialog header="Godfather I" [(visible)]="display" modal="modal" [responsive]="true" [width]="350" [minWidth]="200" [minY]="70">
            <span>The story begins as Don Vito Corleone, the head of a New York Mafia family, oversees his daughter's wedding. 
                His beloved son Michael has just come home from the war, but does not intend to become part of his father's business. 
                Through Michael's life the nature of the family business becomes clear. The business of the family is just like the head of the family, 
                kind and benevolent to those who give respect,
                but given to ruthless violence whenever anything stands against the good of the family.</span>
                <p-footer>
                    <button type="button" pButton icon="ion-checkmark-round" (click)="display=false" label="Yes"></button>
                    <button type="button" pButton icon="ion-close-round" (click)="display=false" label="No"></button>
                </p-footer>
        </p-dialog>
        <button type="button" (click)="showDialog()" pButton icon="ion-forward" label="Show"></button>
})
export class Dialog {
    display: boolean = false;

    showDialog() {
        this.display = true;
    }
}
`
};


// WEBPACK FOOTER //
// ./src/app/code/dialog.ts